export default {
  init() {
    $('#quitar-mute').click( function (){
      if( $('video').prop('muted', true) )
      {
        $('video').prop('muted', false);
        $('#quitar-mute').css('display','none');
        $('#mute-video').css('display','block');
      }
    });

    $('#mute-video').click( function (){
      $('video').prop('muted', true);
      $('#quitar-mute').css('display','block');
      $('#mute-video').css('display','none');
    });
    // JavaScript to be fired on all pages
    let contador = 0;
    $('.hamburger').click(function () {
      $(this).toggleClass('is-active');
      if(contador == 0 ) {
        $('.menuMovil').animate({
          'display': 'block',
          'left': '0',
        }, 500);
        contador = 1;
      } else {
        $('.menuMovil').animate({
          'display': 'block',
          'left': '-100vw',
        }, 500);
        contador = 0;
      }
    });

    let miVariable = '<a class="brand efectosLogo" href="/" id="logo-header"><img src="/wp-content/themes/greasetema/dist/images/homeInteriores/logo.png" alt="logo Grease el musical" class="logo-fondo logoHeader">'
    +'<img src="/wp-content/themes/greasetema/dist/images/homeInteriores/logogreasecapas.png" alt="logo Grease el musical" class="destello destello-01 logoHeader">'
    +'<img src="/wp-content/themes/greasetema/dist/images/homeInteriores/logogreasecapas1.png" alt="logo Grease el musical" class="destello destello-02 logoHeader">'
    +'<img src="/wp-content/themes/greasetema/dist/images/homeInteriores/logogreasecapas2.png" alt="logo Grease el musical" class="destello destello-03 logoHeader">'
    +'</a>';


$('#menu-menu-principal .separadormenu').after(miVariable);


   /* $('.menuMovil .nav-link').on('click', function() {
      $('.hamburger').removeClass('is-active');
      $('.menuMovil').animate({
        'display': 'block',
        'left': '-100vw',
      }, 500);
      contador = 0;
    })*/

    var altura = $('.banner').offset().top;

    $(window).on('scroll', function(){
      if ( $(window).scrollTop() > altura ){
        $('.banner').addClass('menu-fixed');
      } else {
        $('.banner').removeClass('menu-fixed');
      }
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js